export { default } from './PopoverMenu';
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/PopoverMenu/index.js